import localization from './helpers/localization';
export const benchShapes = [
    {
        name: "Suora ilman upotusta",
        localizationResourceName:"straightWithoutEmbedding",
        image: "img/{0}/0000.png",
        size: "min",
        code: "0000",
        defaultDoorPosition: "left",
        defaultStovePosition: "right",
        halfHeightGlassImage: "min_lasiseina2",
        numberOfBenchLightFibersNeeded: 16,
        stoveEmbedding: false,
        stoveInCorner: true,
        straightAtBackWall: true,
        straightAtLeftWall: false,
        straightAtRightWall: false,
        straightAtFrontWall: false,
        recommendedSaunaSize: { width: 1700, depth: 1700 },
        mininimumSaunaSize: { width: 1300, depth: 1300 }
    },
    {
        name: "Suora kiuasupotuksella",
        localizationResourceName: "straightWithEmbedding",
        image: "img/{0}/0001.png",
        size: "min",
        code: "0001",
        defaultDoorPosition: "left",
        defaultStovePosition: "right",
        halfHeightGlassImage: "min_lasiseina2",
        numberOfBenchLightFibersNeeded: 16,
        stoveEmbedding: true,
        stoveInCorner: true,
        straightAtBackWall: true,
        straightAtLeftWall: false,
        straightAtRightWall: false,
        straightAtFrontWall: false,
        recommendedSaunaSize: { width: 1700, depth: 1700 },
        mininimumSaunaSize: { width: 1400, depth: 1400 }
    },
    {
        name: "Suora ilman upotusta",
        localizationResourceName: "straightWithoutEmbedding",
        image: "img/{0}/0002.png",
        size: "min",
        code: "0002",
        defaultDoorPosition: "left",
        defaultStovePosition: "backLeft",
        halfHeightGlassImage: "min_lasiseina5",
        numberOfBenchLightFibersNeeded: 16,
        stoveEmbedding: false,
        stoveInCorner: true,
        straightAtBackWall: false,
        straightAtLeftWall: true,
        straightAtRightWall: false,
        straightAtFrontWall: false,
        recommendedSaunaSize: { width: 1700, depth: 1700 },
        mininimumSaunaSize: { width: 1300, depth: 1300 }
    },
    {
        name: "Suora kiuasupotuksella",
        localizationResourceName: "straightWithEmbedding",
        image: "img/{0}/0003.png",
        size: "min",
        code: "0003",
        defaultDoorPosition: "left",
        defaultStovePosition: "backLeft",
        halfHeightGlassImage: "min_lasiseina5",
        numberOfBenchLightFibersNeeded: 16,
        stoveEmbedding: true,
        stoveInCorner: true,
        straightAtBackWall: false,
        straightAtLeftWall: true,
        straightAtRightWall: false,
        straightAtFrontWall: false,
        recommendedSaunaSize: { width: 1700, depth: 1700 },
        mininimumSaunaSize: { width: 1400, depth: 1400 }
    },
    {
        name: "U-malli ilman upotusta",
        localizationResourceName: "uModelWithoutEmbedding",
        image: "img/{0}/0004.png",
        size: "min",
        code: "0004",
        defaultDoorPosition: "left",
        defaultStovePosition: "backLeft",
        halfHeightGlassImage: "min_lasiseina4",
        numberOfBenchLightFibersNeeded: 16,
        stoveEmbedding: false,
        stoveInCorner: true,
        straightAtBackWall: true,
        straightAtLeftWall: true,
        straightAtRightWall: false,
        straightAtFrontWall: true,
        recommendedSaunaSize: { width: 1800, depth: 2200 },
        mininimumSaunaSize: { width: 1800, depth: 1600 }
    },
    {
        name: "L-malli ilman upotusta",
        localizationResourceName: "lModelWithoutEmbedding",
        image: "img/{0}/0005.png",
        numberOfBenchLightFibersNeeded: 16,
        size: "min",
        code: "0005",
        defaultDoorPosition: "left",
        defaultStovePosition: "right",
        halfHeightGlassImage: "min_lasiseina3",
        stoveEmbedding: false,
        useCommonStove: true,
        stoveInCorner: true,
        straightAtBackWall: true,
        straightAtLeftWall: false,
        straightAtRightWall: true,
        straightAtFrontWall: false,
        recommendedSaunaSize: { width: 1700, depth: 1700 },
        mininimumSaunaSize: { width: 1400, depth: 1400 }
    },
    {
        name: "L-malli ilman upotusta",
        localizationResourceName: "lModelWithoutEmbedding",
        image: "img/{0}/0006.png",
        size: "min",
        code: "0006",
        defaultDoorPosition: "left",
        defaultStovePosition: "backLeft",
        halfHeightGlassImage: "min_lasiseina5",
        numberOfBenchLightFibersNeeded: 16,
        stoveEmbedding: false,
        stoveInCorner: true,
        straightAtBackWall: true,
        straightAtLeftWall: true,
        straightAtRightWall: false,
        straightAtFrontWall: false,
        recommendedSaunaSize: { width: 1700, depth: 1700 },
        mininimumSaunaSize: { width: 1400, depth: 1400 }
    },
    {
        name: "L-malli kiuasupotuksella",
        localizationResourceName: "lModelWithEmbedding",
        image: "img/{0}/0007.png",
        size: "min",
        code: "0007",
        defaultDoorPosition: "left",
        defaultStovePosition: "right",
        halfHeightGlassImage: "min_lasiseina2",
        numberOfBenchLightFibersNeeded: 16,
        stoveEmbedding: true,
        stoveInCorner: true,
        straightAtBackWall: true,
        straightAtLeftWall: false,
        straightAtRightWall: true,
        straightAtFrontWall: false,
        recommendedSaunaSize: { width: 1800, depth: 1800 },
        mininimumSaunaSize: { width: 1500, depth: 1500 }
    },
    {
        name: "L-malli kiuasupotuksella",
        localizationResourceName: "lModelWithEmbedding",
        image: "img/{0}/0008.png",
        size: "min",
        code: "0008",
        defaultDoorPosition: "left",
        defaultStovePosition: "backLeft",
        halfHeightGlassImage: "min_lasiseina5",
        numberOfBenchLightFibersNeeded: 16,
        stoveEmbedding: true,
        stoveInCorner: true,
        straightAtBackWall: true,
        straightAtLeftWall: true,
        straightAtRightWall: false,
        straightAtFrontWall: false,
        recommendedSaunaSize: { width: 1800, depth: 1800 },
        mininimumSaunaSize: { width: 1500, depth: 1500 }
    },
    {
        name: "L-malli kiuasupotuksella",
        localizationResourceName: "lModelWithEmbedding",
        image: "img/{0}/0009.png",
        size: "min",
        code: "0009",
        defaultDoorPosition: "left",
        defaultStovePosition: "right",
        halfHeightGlassImage: "min_lasiseina2",
        numberOfBenchLightFibersNeeded: 16,
        stoveEmbedding: true,
        stoveInCorner: true,
        straightAtBackWall: true,
        straightAtLeftWall: true,
        straightAtRightWall: false,
        straightAtFrontWall: false,
        recommendedSaunaSize: { width: 1800, depth: 1800 },
        mininimumSaunaSize: { width: 1500, depth: 1500 }
    },
    {
        name: "U-malli kiuasupotuksella",
        localizationResourceName: "uModelWithEmbedding",
        image: "img/{0}/0010.png",
        size: "med",
        code: "0010",
        defaultDoorPosition: "left",
        defaultStovePosition: "right",
        halfHeightGlassImage: "med_lasiseina1",
        numberOfBenchLightFibersNeeded: 16,
        stoveEmbedding: true,
        useCommonStove: true,
        stoveInCorner: true,
        straightAtBackWall: true,
        straightAtLeftWall: true,
        straightAtRightWall: true,
        straightAtFrontWall: false,
        recommendedSaunaSize: { width: 2200, depth: 1800 },
        mininimumSaunaSize: { width: 1800, depth: 1600 }
    },
    {
        name: "Iso U-malli ilman upotusta",
        localizationResourceName: "largeUModelWithoutEmbedding",
        image: "img/{0}/0011.png",
        size: "med",
        code: "0011",
        defaultDoorPosition: "center",
        defaultStovePosition: "right",
        halfHeightGlassImage: "med_lasiseina2",
        numberOfBenchLightFibersNeeded: 16,
        stoveEmbedding: false,
        stoveInCorner: true,
        straightAtBackWall: true,
        straightAtLeftWall: true,
        straightAtRightWall: true,
        straightAtFrontWall: false,
        recommendedSaunaSize: { width: 2200, depth: 1800 },
        mininimumSaunaSize: { width: 1800, depth: 1600 }
    },
    {
        name: "U-malli ilman upotusta",
        localizationResourceName: "uModelWithoutEmbedding",
        image: "img/{0}/0012.png",
        size: "med",
        code: "0012",
        defaultDoorPosition: "center",
        defaultStovePosition: "right",
        halfHeightGlassImage: "med_lasiseina1",
        numberOfBenchLightFibersNeeded: 16,
        stoveEmbedding: false,
        stoveInCorner: true,
        straightAtBackWall: true,
        straightAtLeftWall: true,
        straightAtRightWall: true,
        straightAtFrontWall: false,
        recommendedSaunaSize: { width: 2200, depth: 1800 },
        mininimumSaunaSize: { width: 1800, depth: 1800 }
    },
    {
        name: "Iso L-malli ilman upotusta",
        localizationResourceName: "largeLModelWithoutEmbedding",
        image: "img/{0}/0013.png",
        size: "max",
        code: "0013",
        defaultDoorPosition: "center",
        defaultStovePosition: "right",
        halfHeightGlassImage: "max_lasiseina3",
        numberOfBenchLightFibersNeeded: 16,
        stoveEmbedding: false,
        useCommonStove: true,
        stoveInCorner: true,
        straightAtBackWall: true,
        straightAtLeftWall: true,
        straightAtRightWall: false,
        straightAtFrontWall: false,
        recommendedSaunaSize: { width: 2400, depth: 1800 },
        mininimumSaunaSize: { width: 1900, depth: 1600 }
    },
    {
        name: "Iso L-malli ilman upotusta",
        localizationResourceName: "largeLModelWithoutEmbedding",
        image: "img/{0}/0014.png",
        size: "max",
        code: "0014",
        defaultDoorPosition: "center",
        defaultStovePosition: "right",
        halfHeightGlassImage: "max_lasiseina1",
        numberOfBenchLightFibersNeeded: 16,
        stoveEmbedding: false,
        useCommonStove: true,
        stoveInCorner: false,
        straightAtBackWall: true,
        straightAtLeftWall: true,
        straightAtRightWall: false,
        straightAtFrontWall: false,
        recommendedSaunaSize: { width: 2400, depth: 1800 },
        mininimumSaunaSize: { width: 1900, depth: 1600 }
    },
    {
        name: "Iso L-malli kiuasupotuksella",
        localizationResourceName: "largeLModelWithEmbedding",
        image: "img/{0}/0015.png",
        size: "max",
        code: "0015",
        defaultDoorPosition: "center",
        defaultStovePosition: "right",
        halfHeightGlassImage: "max_lasiseina3",
        numberOfBenchLightFibersNeeded: 16,
        stoveEmbedding: true,
        useCommonStove: true,
        stoveInCorner: true,
        straightAtBackWall: true,
        straightAtLeftWall: false,
        straightAtRightWall: true,
        straightAtFrontWall: false,
        recommendedSaunaSize: { width: 2400, depth: 1800 },
        mininimumSaunaSize: { width: 2000, depth: 1600 }
    },
    {
        name: "Iso L-malli kiuasupotuksella",
        localizationResourceName: "largeLModelWithEmbedding",
        image: "img/{0}/0016.png",
        size: "max",
        code: "0016",
        defaultDoorPosition: "left",
        defaultStovePosition: "center",
        halfHeightGlassImage: "max_lasiseina1",
        numberOfBenchLightFibersNeeded: 16,
        stoveEmbedding: true,
        useCommonStove: true,
        stoveInCorner: false,
        straightAtBackWall: true,
        straightAtLeftWall: true,
        straightAtRightWall: false,
        straightAtFrontWall: false,
        recommendedSaunaSize: { width: 2400, depth: 1800 },
        mininimumSaunaSize: { width: 2000, depth: 1600 }
    },
    {
        name: "Iso U-malli kiuasupotuksella",
        localizationResourceName: "largeUModelWithEmbedding",
        image: "img/{0}/0017.png",
        size: "max",
        code: "0017",
        defaultDoorPosition: "center",
        defaultStovePosition: "right",
        halfHeightGlassImage: "max_lasiseina3",
        numberOfBenchLightFibersNeeded: 16,
        stoveEmbedding: true,
        useCommonStove: true,
        stoveInCorner: true,
        straightAtBackWall: true,
        straightAtLeftWall: true,
        straightAtRightWall: true,
        straightAtFrontWall: false,
        recommendedSaunaSize: { width: 2200, depth: 1800 },
        mininimumSaunaSize: { width: 1800, depth: 1600 }
    },
    {
        name: "Vastakkainen L-malli",
        localizationResourceName: "oppositeLModel",
        image: "img/{0}/0018.png",
        size: "max",
        code: "0018",
        defaultDoorPosition: "center",
        defaultStovePosition: "backWallCenter",
        halfHeightGlassImage: "max_lasiseina3",
        numberOfBenchLightFibersNeeded: 16,
        stoveEmbedding: true,
        useCommonStove: true,
        stoveInCorner: false,
        straightAtBackWall: true,
        straightAtLeftWall: true,
        straightAtRightWall: true,
        straightAtFrontWall: false,
        recommendedSaunaSize: { width: 2600, depth: 1800 },
        mininimumSaunaSize: { width: 2500, depth: 1600 }
    },
    {
        name: "Vastakkainen suora",
        localizationResourceName: "oppositeStraightModel",
        image: "img/{0}/0019.png",
        size: "max",
        code: "0019",
        defaultDoorPosition: "center",
        defaultStovePosition: "backWallCenter",
        halfHeightGlassImage: "max_lasiseina3",
        numberOfBenchLightFibersNeeded: 16,
        stoveEmbedding: true,
        useCommonStove: true,
        stoveInCorner: false,
        straightAtBackWall: false,
        straightAtLeftWall: true,
        straightAtRightWall: true,
        straightAtFrontWall: false,
        recommendedSaunaSize: { width: 2600, depth: 1800 },
        mininimumSaunaSize: { width: 2400, depth: 1600 }        
    },
    {
        name: "Iso L-malli ilman kiuasupotusta",
        localizationResourceName: "largeLModelWithoutEmbedding",
        image: "img/{0}/0020.png",
        size: "spc1",
        code: "0020",
        defaultDoorPosition: "center",
        defaultStovePosition: "right",
        halfHeightGlassImage: "spc_kaakeliseina_Q",
        numberOfBenchLightFibersNeeded: 16,
        stoveEmbedding: false,
        stoveInCorner: false,
        straightAtBackWall: true,
        straightAtLeftWall: true,
        straightAtRightWall: false,
        straightAtFrontWall: false,
        recommendedSaunaSize: { width: 1800, depth: 2400 },
        mininimumSaunaSize: { width: 1600, depth: 1800 }
    },
    {
        name: "Iso L-malli kiuasupotuksella",
        localizationResourceName: "largeLModelWithEmbedding",
        image: "img/{0}/0021.png",
        size: "spc1",
        code: "0021",
        defaultDoorPosition: "left",
        defaultStovePosition: "center",
        halfHeightGlassImage: "spc_kaakeliseina_Q",
        numberOfBenchLightFibersNeeded: 16,
        stoveEmbedding: true,
        stoveInCorner: false,
        straightAtBackWall: true,
        straightAtLeftWall: true,
        straightAtRightWall: false,
        straightAtFrontWall: false,
        recommendedSaunaSize: { width: 1800, depth: 2400 },
        mininimumSaunaSize: { width: 1600, depth: 1800 }
    },
    {
        name: "U-malli kiuasupotuksella",
        localizationResourceName: "U-modell med aggregatinfällning",
        image: "img/{0}/0022.png",
        size: "spc2",
        code: "0022",
        defaultDoorPosition: "left",
        defaultStovePosition: "backLeft",
        halfHeightGlassImage: "spc_kaakeliseina_Q",
        numberOfBenchLightFibersNeeded: 16,
        stoveEmbedding: true,
        stoveInCorner: true,
        straightAtBackWall: true,
        straightAtLeftWall: true,
        straightAtRightWall: true,
        straightAtFrontWall: false,
        recommendedSaunaSize: { width: 1800, depth: 2200 },
        mininimumSaunaSize: { width: 1600, depth: 1800 }
    }
];
var defaultShapes =
    [
        benchShapes[0],
        benchShapes[1],
        benchShapes[5],
        benchShapes[7],
        benchShapes[10],
        benchShapes[12],
        benchShapes[18],
        benchShapes[19]
    ];

export const benchModels =
    [
        {
            name: "classic",
            image: "img/classic/0007.png",
            useProfileLayer: true,
            descriptionLocalizationStringName: "descriptionClassic",
            supportsLinearLed: false,
            stoolHoleArcRadius: 360,
            upperBenchDepth: 540,
            drawBottomBench: true,
            bottomBenchUnderUpperBench: false,
            availableShapes: defaultShapes,
            allShapesPossilbe: true,
            renderFrontWall: true,
            supportsCadDrawing: true

        },
        {
            name: "relax",
            image: "img/relax/0007.png",
            useProfileLayer: false,
            defaultLighting: "LedStripe",
            descriptionLocalizationStringName: "descriptionRelax",
            supportsLinearLed: true,
            stoolHoleArcRadius: 0,
            upperBenchDepth: 550,
            drawBottomBench: true,
            bottomBenchUnderUpperBench: false,
            availableShapes: defaultShapes,
            allShapesPossilbe: true,
            renderFrontWall: true,
            supportsCadDrawing: true
        },
        {
            name: "relax XL",
            image: "img/relaxxl/0007.png",
            defaultLighting: "LedStripe",
            useProfileLayer: false,
            descriptionLocalizationStringName: "descriptionRelaxXL",
            stoolHoleArcRadius: 0,
            supportsLinearLed: true,
            upperBenchDepth: 550,
            drawBottomBench: true,
            bottomBenchUnderUpperBench: true,
            availableShapes: defaultShapes,
            allShapesPossilbe: true,
            renderFrontWall: true,
            supportsCadDrawing: true
        },
       {
            name: "Log",
           image: "img/log/0007.png",
           defaultLighting: "LedStripe",
            useProfileLayer: false,
            descriptionLocalizationStringName: "descriptionLog",
            stoolHoleArcRadius: 0,
            supportsLinearLed: true,
            upperBenchDepth: 600,
            drawBottomBench: true,
            bottomBenchUnderUpperBench: true,
            allShapesPossilbe: true,
            availableShapes: defaultShapes,
            renderFrontWall: true,
            supportsCadDrawing: true
        },
        {
            name: "wave",
            image: "img/wave/0007.png",
            useProfileLayer: true,
            descriptionLocalizationStringName: "descriptionWave",
            stoolHoleArcRadius: 279,
            supportsLinearLed: false,
            upperBenchDepth: 598,
            drawBottomBench: true,
            bottomBenchUnderUpperBench: false,
            allShapesPossilbe: true,
            availableShapes: defaultShapes,
            renderFrontWall: true,
            supportsCadDrawing: true
        },
        {
            name: "elegance",
            image: "img/elegance/0007.png",
            useProfileLayer: true,
            descriptionLocalizationStringName: "descriptionElegance",
            stoolHoleArcRadius: 279,
            supportsLinearLed: false,
            upperBenchDepth: 598,
            drawBottomBench: true,
            bottomBenchUnderUpperBench: false,
            allShapesPossilbe: true,
            availableShapes: defaultShapes,
            renderFrontWall: true,
            supportsCadDrawing: true
        },
        {
            name: "basic",
            image: "img/basic/0000.png",
            useProfileLayer: false,
            descriptionLocalizationStringName: "descriptionBasic",
            stoolHoleArcRadius: 0,
            supportsLinearLed: false,
            upperBenchDepth: 500,
            drawBottomBench: false,
            bottomBenchUnderUpperBench: false,
            allShapesPossilbe: false,
            availableShapes: [benchShapes[0], benchShapes[2], benchShapes[5], benchShapes[6], benchShapes[20]],
            renderFrontWall: true,
            supportsCadDrawing: true
        },
        {
            name: "swing_clean",
            image: "img/swingclean/0005.png",
            useProfileLayer: false,
            descriptionLocalizationStringName: "descriptionSwingClean",
            stoolHoleArcRadius: 0,
            supportsLinearLed: true,
            upperBenchDepth: false,
            drawBottomBench: false,
            usesMetalPartsLayer: true,
            bottomBenchUnderUpperBench: false,
            allShapesPossilbe: false,
            availableShapes: [benchShapes[0], benchShapes[5], benchShapes[13], benchShapes[19]],
            renderFrontWall: false,
            shapesWithOwnStoves: [benchShapes[19]],
            alternateShapeNames: { "0000": "straight", "0005": "lModel", "0013": "largeLModel" },
            supportsCadDrawing: false
        }
    ];
export const stoves =
    [

        {
            name: "Harvia Clilindro XE",
            power: "6-10,8 kW",
            recommendedSaunaSize: "6–18 m³",
            canBeEmbedded: true,
            cornerStove: false,
            cadImage: "img/stoves/cilindroHpc2.png",
            id: "harvia_clilindro_ee",
            image: "img/stoves/cilindro_ee.jpg",
            exportID: "Harvia Cilindro XE",
            layerId: "harvia_clilindro_ee"
        },
        {
            name: "Iki Pilari",
            power: "4,5-10,5 kW",
            recommendedSaunaSize: "3–18 m³",
            canBeEmbedded: true,
            cornerStove: false,
            id: "iki_pilari",
            image: "img/stoves/iki_pilari.jpg",
            exportID: "Iki Pilari",
            layerId: "iki_pilari"
        },       

 
        {
            name: "Iki Mini Plus",
            power: "",
            recommendedSaunaSize: "8–13 m³",
            canBeEmbedded: false,
            cornerStove: false,
            id: "iki_mini_plus",
            layerId: "iki_mini_plus",
            image: "img/stoves/iki_mini_plus.jpg",
            exportID: "IKI Mini Plus",
            cadImage:"img/stoves/puukiuas600.png"
        },
        {
            name: "Harvia Forte",
            power: "6-9 kW",
            recommendedSaunaSize: "6–14 m³",
            canBeEmbedded: true,
            cornerStove: false,
            id: "harvia_forte",
            layerId: "harvia_forte",
            image: "img/stoves/harvia_forte.jpg",
            exportID: "Harvia forte"
        },
        {
            name: "Harvia M3",
            power: "",
            recommendedSaunaSize: "8–13 m³",
            canBeEmbedded: false,
            cornerStove: false,
            id: "harvia_m3",
            layerId: "harvia_m3",
            image: "img/stoves/harvia_m3.jpg",
            exportID: "Harvia M3"
        },
        {
            name: "Iki Kulma",
            power: "6,6-9 kW",
            recommendedSaunaSize: "5–16 m³",
            canBeEmbedded: true,
            cornerStove: true,
            id: "iki_kulma",
            layerId: "iki_kulma",
            image: "img/stoves/iki_kulma.jpg",
            exportID: "Kulma-IKI"
        },  
        {
            name: "Iki Seina",
            power: "6,6-9 kW",
            recommendedSaunaSize: "5–16 m³",
            canBeEmbedded: true,
            cornerStove: false,
            id: "iki_seina",
            layerId: "iki_seina",
            image: "img/stoves/iki_seina.jpg",
            exportID: "Seinä-IKI"
        },
        {
            name: "Magnum Lite Pylväs",
            power: "6,6-10,5 kW",
            recommendedSaunaSize: "6–18 m³",
            canBeEmbedded: true,
            cornerStove: false,
            id: "magnum_lite",
            layerId: "magnum_lite",
            image: "img/stoves/magnum_lite.jpg",
            exportID: "Magnum Lite Pylväs"
        },
        {
            name: "Magnum Lite Malja",
            power: "6,6-10,5 kW",
            recommendedSaunaSize: "6–18 m³",
            canBeEmbedded: true,
            cornerStove: false,
            id: "magnum_malja",
            layerId: "magnum_malja",
            image: "img/stoves/magnum_lite_malja.jpg",
            exportID: "Magnum Lite Malja"
        },
        {
            name: "Magnum Original Pylväs",
            power: "6,6-10,5 kW",
            recommendedSaunaSize: "6–18 m³",
            canBeEmbedded: true,
            cornerStove: false,
            id: "magnum_original",
            layerId: "magnum_original",
            image: "img/stoves/magnum_original.jpg",
            exportID: "Magnum Original Pylväs"
        },
        {
            name: "Tulikivi Rae",
            power: "6,8-10,5 kW",
            recommendedSaunaSize: "5–15 m³",
            canBeEmbedded: true,
            cornerStove: false,
            id: "tulikivi_rae",
            layerId: "tulikivi_rae",
            image: "img/stoves/tulikivi_rae.jpg",
            exportID: "Tulikivi Rae"
        },
        {
            name: "Tulikivi Riite",
            power: "6,8-10,5 kW",
            recommendedSaunaSize: "5–15 m³",
            canBeEmbedded: true,
            cornerStove: false,
            id: "tulikivi_riite",
            layerId: "tulikivi_riite",
            image: "img/stoves/tulikivi_riite.jpg",
            exportID: "Tulikivi Riite"
        },
        {
            name: "Harvia Vega",
            power: "6-8 kW",
            recommendedSaunaSize: "5–8 m³",
            canBeEmbedded: false,
            cornerStove: false,
            cadImage: "img/stoves/vega8kw.png",
            id: "harvia_vega",
            layerId: "harvia_vega",
            image: "img/stoves/harvia_vega.jpg",
            exportID: "Harvia Vega"
        },
        /*{
            name: "Sawo Round",
            power: "6-12 kW",
            recommendedSaunaSize: "5-18 m³",
            canBeEmbedded: true,
            cornerStove: false,
            id: "sawo_round",
            layerId: "iki_pilari",
            image: "img/stoves/sawo_round.jpg",
            exportID: "Sawo Round"
        },
        {
            name: "Sawo Tower Wall",
            power: "6-12 kW",
            recommendedSaunaSize: "5-18 m³",
            canBeEmbedded: true,
            cornerStove: false,
            id: "savo_seina",
            layerId: "iki_seina",
            image: "img/stoves/sawo_seina.jpg",
            exportID: "Sawo Tower Wall"
        },
        {
            name: "Sawo Tower Corner",
            power: "6-12 kW",
            recommendedSaunaSize: "5-18 m³",
            canBeEmbedded: true,
            cornerStove: true,
            id: "savo_kulma",
            layerId: "iki_kulma",
            image: "img/stoves/sawo_kulma.jpg",
            exportID: "Sawo Tower Corner"
        },*/
        {
            name: "Oma kiuas",
            canBeEmbedded: true,
            cornerStove: false,
            id: "ownStove",
            layerId: "",
            exportID: "Oma kiuas"
        }      
    ];

export const clientConfigurations =
{
    default: {
        showPrices: false,    
        avalaibleBenhcModels: [benchModels[1], benchModels[0], benchModels[2], benchModels[5], benchModels[4]],
        slideConfig: "default",
        showPanelDirection: false,
        canMoveDoor: true,
        canMoveStove: true,
        showInstructionBox: true,
        drawBenchCadPicture: true,
        allowSkipMeasurements: true,
        showNoLightOption: true,
        filterShapesBySize: true,
        allowRemovalOfPanels: true,
        allowRemovalOfStove: true,
        renderFrontWall: true,
        showBenchMinimumSizeLimits: true,
        displayAllShapes: false
    },   
    talotehdas: {
        showPrices: false,
        slideConfig: "talotehdas",
        selectableProducts: {
            hasBench: true,
            hasPaneling: true,
            hasStove: true,
            hasLights: true,
            hasDoor: true
        },
        showPanelDirection: false,
        canMoveDoor: true,
        canMoveStove: true,
        showInstructionBox: true,
        drawBenchCadPicture: true,
        allowSkipMeasurements: false,
        showNoLightOption: true,
        filterShapesBySize: false,
        allowRemovalOfPanels: true,
        allowRemovalOfStove: true,
        renderFrontWall: true,
        showBenchMinimumSizeLimits: true,
        displayAllShapes: true
    },
    julkinen: {
        showPrices: false,
        slideConfig: "swingclean",
        selectableProducts: {
            hasBench: true,
            hasPaneling: true,
            hasStove: false,
            hasLights: true,
            hasDoor: false
        },
        avalaibleBenhcModels: [benchModels[7]],
        showPanelDirection: false,
        canMoveDoor: true,
        canMoveStove: true,
        showInstructionBox: true,
        drawBenchCadPicture: true,
        allowSkipMeasurements: false,
        showNoLightOption: true,
        filterShapesBySize: false,
        allowRemovalOfPanels: true,
        allowRemovalOfStove: true,
        renderFrontWall: false,
        showBenchMinimumSizeLimits: false,
        displayAllShapes: false
    },
    jalleenmyyja: {
        showPrices: false,       
        slideConfig: "default",
        showPanelDirection: false,
        canMoveDoor: true,
        canMoveStove: true,
        showInstructionBox: true,
        drawBenchCadPicture: true,
        allowSkipMeasurements: false,
        showNoLightOption: true,
        filterShapesBySize: true,
        allowRemovalOfPanels: true,
        allowRemovalOfStove: true,
        renderFrontWall: true,
        showBenchMinimumSizeLimits: true,
        displayAllShapes: false,
        showResellerAssistanceRequest: true
    },
    dooronly: {
        showPrices: false,
        slideConfig: "dooronly",
        selectableProducts: {
            hasBench: false,
            hasPaneling: false,
            hasStove: false,
            hasLights: false,
            hasDoor: true
        },
        avalaibleBenhcModels: false,
        showPanelDirection: false,
        canMoveDoor: true,
        canMoveStove: true,
        showInstructionBox: true,
        drawBenchCadPicture: false,
        allowSkipMeasurements: true,
        showNoLightOption: true,
        filterShapesBySize: false,
        allowRemovalOfPanels: false,
        allowRemovalOfStove: false,
        renderFrontWall: true,
        showBenchMinimumSizeLimits: false,
        displayAllShapes: false
    },


}




export const trackingSettings =
{
    appName: "valintaohjelma",
    accountID: "G-LFYP21V2SS"             
};
export const avalaibleLayerResolutions = [{ width: 320, height: 200 }, { width: 960, height: 600 }, { width: 1920, height: 1200 }];



let contentRootf;
let servicerootf;
let layerPathf;


if (process.env.NODE_ENV !== 'production') {
    contentRootf = "./";
    servicerootf = "https://localhost:60374/";
    layerPathf = "./layer/";

}
else {
    contentRootf = "/valintaohjelma/";
    // servicerootf = "https://services.sunsauna.fi/OfferRequestServices/";
    servicerootf = "https://services.sunsauna.fi/OfferRequestServices/";
    layerPathf = "/valintaohjelma/layer/";
}


export const layerPath = layerPathf;
export const serviceroot = servicerootf;
export const contentRoot = contentRootf;
